/** Icon-only actions in table rows — căn giữa, icon hơi to hơn. */
export const TABLE_ACTION_ICON_BUTTON_SX = {
  width: 28,
  height: 28,
  padding: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  verticalAlign: 'middle',
  '& .MuiSvgIcon-root': {
    fontSize: 16,
    display: 'block',
  },
} as const
